export default "__VITE_ASSET__D1NC9nzp__"